<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import _ from "lodash";
import store from "../../../../../stores/application/index.js.erb";
import FormationHostelOrder from "../../Cards/Commissions/FormationHostelOrder.vue";
import HostelOrdersStore from "../../../../../stores/application/hostel/hostelOrders_store";

export default {
  name: "WorkingWithOrders",
  props: {
    department_id: String
  },
  components: {
    FormationHostelOrder
  },
  data: () => ({
    step_window: 1,
    headers_table_orders: [
      {text: '#НОМЕР', value: 'order_id1c', sortable: false},
      {text: 'ВИД ПРИКАЗА', value: 'name_order', sortable: false},
      {text: 'КОЛ-ВО СТУДЕНТОВ', value: 'order_elements.length', sortable: false, align: 'center'},
      {text: 'СОЗДАН', value: 'created_at', sortable: false},
      {text: 'ДЕЙСТВИЯ', value: 'actions', sortable: false, align: 'center'},
    ],
    headers_table_elements_order: [
      {text: 'Студент', value: 'person_name', sortable: false},
      {text: 'Общежитие', value: 'name_hostel', sortable: false},
      {text: 'Комната', value: 'name_room', sortable: false, align: 'center'},
    ],
    selected_table: [],
    pageCount: 0,
    page: 1,
    drawer: false,
    current_order: {}
  }),
  mounted() {
  },
  computed: {
    ...mapState({
      hostel_orders: state => state.hostelOrders.hostel_orders,
    }),
    ...mapGetters({}),
  },
  methods: {
    ...mapMutations({}),
    ...mapActions({
      GetDistributionPersonsRecords: 'hostelOrders/GetDistributionPersonsRecords',
      IndexOrder: 'hostelOrders/IndexOrder'
    }),
    async setStepListOrders() {
      this.step_window = 1
      await this.IndexOrder(this.department_id)
    },
    async setStepFormingOrder() {
      await this.GetDistributionPersonsRecords(this.department_id)
      this.step_window = 2
    },
    closeDialogFormHostelOrder() {
      this.$emit('closeDialogFormHostelOrder')
    },
    openDetailsOrder(order){
      this.drawer = true
      this.current_order = order
    }
  },
}
</script>

<template>
  <v-card height="650px" outlined class="rounded-xl">
    <v-window style="height: 100%" v-model="step_window">
      <v-window-item style="height: 100%" :value="1">
        <v-card height="100%" elevation="0" v-if="hostel_orders.length === 0">
          <v-card-title class="text-center">

            <v-row no-gutters>
              <v-spacer/>
              <v-btn
                  icon
                  @click="closeDialogFormHostelOrder()"
              >
                <v-icon size="20">
                  fa-times
                </v-icon>
              </v-btn>
              <v-col cols="12" class="text-center">
                <div class="text-md-h5 text-sm-h6">Формирование приказов на проживание</div>
              </v-col>
              <v-col class="mt-2" cols="12">
                <v-divider/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="text-center">
            Не один из приказов ещё не сформирован
          </v-card-text>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn
                  @click="setStepFormingOrder"
                  color="teal darken-1"
                  outlined
                  rounded
              >
                <v-icon
                    left
                    dark
                >
                  fa-id-card
                </v-icon>
                Сформировать приказ
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
        <v-card v-else height="100%" elevation="0">
          <v-card-title>
            <div class="text--secondary d-flex justify-center">Список приказов</div>
            <v-spacer/>
            <v-btn
                icon
                @click="closeDialogFormHostelOrder()"
            >
              <v-icon size="20">
                fa-times
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="height: calc(100% - 125px)">
            <v-data-table
                v-model="selected_table"
                :headers="headers_table_orders"
                :items="hostel_orders"
                :items-per-page="10"
                :page.sync="page"
                loading-text="Загрузка заявлений... пожалуйста подождите"
                @page-count="pageCount = $event"
                no-data-text="По предложенным критериям данные отсутствуют"
                hide-default-footer
                mobile-breakpoint="0"
            >
              <template v-slot:top>
                <div class="d-flex justify-end">
                  <v-btn
                      rounded
                      small
                      @click="setStepFormingOrder"
                      color="teal darken-1"
                      outlined
                  >
                    <v-icon
                        left
                        dark
                    >
                      fa-id-card
                    </v-icon>
                    Сформировать новый приказ
                  </v-btn>
                </div>
              </template>
              <template v-slot:item.name_order="{ item }">
                Заселение в общежитие
              </template>
              <template v-slot:item.actions="{ item }">
                <v-icon size="15px" @click="openDetailsOrder(item)">
                  fa-eye
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-pagination
                class="mx-auto"
                v-model="page"
                :length="pageCount"
                total-visible="8"
                color="teal"
                circle
            ></v-pagination>
          </v-card-actions>
        </v-card>
        <v-navigation-drawer
            class="rounded-xl"
            width="400px"
            v-model="drawer"
            right
            touchless
            absolute
            temporary
        >
          <v-card elevation="0" class="overflow-auto">
            <v-card-title>
              <v-btn absolute icon @click="drawer = !drawer">
                <v-icon size="15px">
                  fa-chevron-left
                </v-icon>
              </v-btn>
              <div class="mx-auto">
                <span>Приказ</span>
                <div class="subtitle-1 text--secondary">{{ "№ " + current_order.order_id1c }}</div>
              </div>
            </v-card-title>
            <v-card-text>
              <div class="text--primary">Содержание приказа</div>
              <v-data-table
                  :headers="headers_table_elements_order"
                  :items="current_order.order_elements"
                  :items-per-page="-1"
                  hide-default-footer
                  mobile-breakpoint="0"
              ></v-data-table>
            </v-card-text>
          </v-card>
        </v-navigation-drawer>
      </v-window-item>
      <v-window-item :value="2">
        <FormationHostelOrder :step_window="step_window" @setStepListOrders="setStepListOrders"/>
      </v-window-item>

    </v-window>
  </v-card>
</template>

<style scoped>

</style>